import { Input, Select, Row, Col, Tag } from "antd";
import useAuthStore from "stores/AuthStore/AuthStore";
import { CODE_STATUS_FILTER_OPTIONS } from "../commons/discountCodes.helpers";
import { CODES_COPY } from "../commons/discountCodes.copy";

/** Filter card for the codes list (copy of EventsFilterBar markup). */
function CodesFilterBar({
  search,
  onSearchChange,
  statusFilter,
  onStatusChange,
  eventFilter,
  onEventChange,
  eventOptions,
  loadingEvents,
  communityFilter,
  onCommunityChange,
  communityOptions,
}) {
  const { isRootUser } = useAuthStore();

  return (
    <div className="bg-card p-4 rounded-2xl border border-border/50">
      <Row gutter={[12, 12]} align="middle">
        <Col xs={24} sm={10} md={7}>
          <Input.Search
            placeholder={CODES_COPY.searchPlaceholder}
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            onSearch={onSearchChange}
            allowClear
          />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Select
            allowClear
            placeholder={CODES_COPY.statusPlaceholder}
            value={statusFilter}
            onChange={onStatusChange}
            options={CODE_STATUS_FILTER_OPTIONS}
            style={{ width: "100%" }}
          />
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            loading={loadingEvents}
            placeholder={CODES_COPY.eventPlaceholder}
            value={eventFilter}
            onChange={onEventChange}
            options={eventOptions}
            optionRender={(option) => (
              <span className="flex items-center justify-between gap-2">
                <span>{option.data.label}</span>
                {option.data.isPast && <Tag>{CODES_COPY.eventPast}</Tag>}
              </span>
            )}
            style={{ width: "100%" }}
          />
        </Col>
        {isRootUser && (
          <Col xs={12} sm={8} md={6}>
            <Select
              allowClear
              value={communityFilter}
              onChange={onCommunityChange}
              options={communityOptions}
              style={{ width: "100%" }}
              showSearch
              optionFilterProp="label"
              placeholder={CODES_COPY.communityPlaceholder}
            />
          </Col>
        )}
      </Row>
    </div>
  );
}

export default CodesFilterBar;
